import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'TableAvatar',
  props: {
    src: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createBlock(_component_q_avatar, { rounded: "" }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: "q-mr-sm tw-object-cover",
        src: _ctx.$props.src
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})